import { useState, useCallback } from "react";
import axios from "axios";
import { message } from "antd";

const usePendingReports = (trainingId, token, memberId) => {
  const [pendingReports, setPendingReports] = useState([]);
  const [pendingCount, setPendingCount] = useState(0);

  const fetchPendingReports = useCallback(async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/TrainingProgressReport/Learner/Pendings?memberId=${memberId}&projectId=${trainingId}`,
        {
          headers: {
            accept: "*/*",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setPendingReports(response.data.pendingTasks || []);
      setPendingCount(response.data.pendingTasks?.length || 0);
    } catch (error) {
      console.error("Error fetching pending reports:", error);
      message.error("Failed to fetch pending reports");
    }
  }, [trainingId, token]);

  return { pendingReports, pendingCount, fetchPendingReports };
};

export default usePendingReports;
